import React from 'react'
import RoundBlueButton from '../BorderButton/round-blue-button'

import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import ReactTooltip from 'react-tooltip'
import ACLCheckPermission from '../ACLCheckPermission'

const EditButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="saveBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-pencil" />} />
)
const RemoveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="deleteBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash" />} />
)

const Row = ({ row, showEdit, index, onEdit, onRemove }) => (
    <tr className={`audience-list audience-list--row }`}>
        <td className="audience-list audience-list--audience">{row.roleId}</td>
        <td className="audience-list audience-list--audience">{row.roleName}</td>
        <td className="audience-list audience-list--audience">{new Date(row.created).toLocaleDateString()}</td>

        {showEdit && (
            <td className="audience-list audience-list--edit">
                <div className="action-wrapper" style={{ justifyContent: 'flex-end' }}>
                    <ACLCheckPermission api="/role" method="PATCH">
                        <ReactTooltip id="saveBtnTooltip" type="dark" effect="solid">
                            <span>Edit role</span>
                        </ReactTooltip>
                        <EditButton disabled={row.username === ''} onClick={() => onEdit(row, index)} />
                    </ACLCheckPermission>
                    &#160;
                    <ACLCheckPermission api="/role" method="DELETE">
                        <ReactTooltip id="deleteBtnTooltip" type="dark" effect="solid">
                            <span>Delete role</span>
                        </ReactTooltip>
                        <RemoveButton disabled={row.new} onClick={() => onRemove(row, index)} />
                    </ACLCheckPermission>
                </div>
            </td>
        )}
    </tr>
)

export default Row
